import { RemoveButton, Section } from '@components'
import AddIcon from '@mui/icons-material/Add'
import { Button } from '@mui/material'
import Box from '@mui/material/Box'
import type { FC } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import type { FormValues } from '../Calculator'
import { defaultFormValues } from '../helpers/config'
import FieldGroup from './FieldGroup'
import { HighlightedContainer } from './styles'

interface FormSectionProps {
	section: keyof FormValues
}

const FormSection: FC<FormSectionProps> = ({ section }: FormSectionProps) => {
	const { t } = useTranslation()

	const { control } = useFormContext()

	const { fields, append, remove } = useFieldArray({
		control,
		name: section,
	})

	const handleAddNewRow = (): void => {
		append({ ...defaultFormValues[section] })
	}

	return (
		<Box mt={2}>
			<Section
				title={t('calculator.sections.title', { context: section }) ?? section}
				subtitle={t('calculator.sections.subtitle', { context: section })}
			>
				<Box>
					{fields.map((field, index) => (
						<HighlightedContainer key={index}>
							<FieldGroup field={field} section={section} index={index} />

							<Box>
								<RemoveButton
									label={t('button.remove')}
									onClick={() => {
										remove(index)
									}}
								/>
							</Box>
						</HighlightedContainer>
					))}
				</Box>

				<Box mt={4}>
					<Button variant="outlined" onClick={handleAddNewRow}>
						<AddIcon />
						{t('button.add')}
					</Button>
				</Box>
			</Section>
		</Box>
	)
}

export { FormSection }
